export default __webpack_public_path__ + "static/google-play-19a39d63aa510cb49730a84f112e3c5e.svg";